import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/Advanced-Settings.svg'

const AdvancedSettingsIcon: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 50 50'} component={Icon} {...props} fill="currentColor" />
export default AdvancedSettingsIcon
